import { IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import styles from './index.module.scss';

const BackButton = ({ onClick }: { onClick(): void }) => {
  return (
    <IconButton className={styles.backBtn} onClick={onClick}>
      <ArrowBackIosNewIcon />
    </IconButton>
  );
};
export default BackButton;
